import { ScheduleChip, fmtDate, fmtDateTime, lineLabel, sigText, linePharmacy } from "./rxShared";
import { CircleSlash, PhoneCall, Store } from "lucide-react";

const yes = (v) => (v ? "Yes" : "No");

function LineFacts({ l, rx, multi }) {
  const ph = linePharmacy(rx, l);
  return (
    <div className="mt-1 flex flex-wrap gap-x-4 gap-y-0.5 text-[11px] text-[#7B6157]">
      <span>Qty {l.quantity} {l.quantity_unit}{l.quantity_words ? ` (${l.quantity_words})` : ""}</span><span>Refills {l.refills}</span>
      {l.days_supply && <span>{l.days_supply} days</span>}{l.start_date && <span>Start {fmtDate(l.start_date)}</span>}
      {l.max_daily_dose && <span>Max daily dose {l.max_daily_dose}</span>}
      {l.daw && <span>Dispense as written</span>}<span>Label {yes(l.label)}</span><span>Med/Ed {yes(l.med_ed)}</span>
      {l.samples && <span>Samples: {l.samples_amount}</span>}
      {l.diagnosis_code && <span>Dx {l.diagnosis_code} {l.diagnosis_label}</span>}
      {multi && ph && <span className="flex items-center gap-1"><Store size={10} /> {ph.name}</span>}
      {l.allergy_override_note && <span className="text-[#8D5A00]">Allergy override: {l.allergy_override_note}</span>}
    </div>
  );
}

/** Medication lines on a prescription, with per-line discontinue and the refill-cancel reminder. */
export function RxLines({ rx, canDiscontinue, onDiscontinue, onCallPharmacy }) {
  const multi = (rx.pharmacy_groups || []).length > 1;
  return (
    <div className="space-y-2" data-testid="rx-detail-lines">
      {rx.lines.map((l, i) => {
        const ph = linePharmacy(rx, l);
        return (
          <div key={l.id} className={`rounded-xl border p-3 ${l.discontinued ? "border-[#E5D3D0] bg-[#FBF8F5]" : "border-[#EFEBE0] bg-white"}`} data-testid={`rx-detail-line-${i}`}>
            <div className="flex flex-wrap items-start justify-between gap-2">
              <div className={`flex flex-wrap items-center gap-1.5 font-semibold text-[#3E2723] ${l.discontinued ? "line-through decoration-[#C62828]/60" : ""}`}>{lineLabel(l)} <ScheduleChip schedule={l.schedule} /></div>
              {l.discontinued ? <span data-testid={`rx-line-discontinued-${i}`} className="rounded-full bg-[#EFEBE0] px-2 py-0.5 text-[10px] font-bold uppercase text-[#6D4C41] ring-1 ring-[#C62828]/40">Discontinued</span>
                : canDiscontinue && <button type="button" data-testid={`rx-line-discontinue-btn-${i}`} onClick={() => onDiscontinue(l)} className="flex items-center gap-1 text-xs font-semibold text-[#C62828] hover:underline"><CircleSlash size={12} /> Discontinue</button>}
            </div>
            <div className="text-xs text-[#6D4C41]">{sigText(l)} · {l.route}</div>
            <LineFacts l={l} rx={rx} multi={multi} />
            {l.discontinued && <div className="mt-1.5 text-[11px] text-[#6D4C41]">Discontinued {fmtDateTime(l.discontinued_at)} by {l.discontinued_by}. Reason: {l.discontinue_reason}</div>}
            {l.refill_cancel_pending && ph && (
              <div className="mt-2 flex flex-wrap items-center justify-between gap-2 rounded-lg bg-[#FFF3E0] px-3 py-2 text-xs font-semibold text-[#8D5A00]" data-testid={`rx-refill-cancel-reminder-${i}`}>
                <span>Call {ph.name}{ph.phone ? ` at ${ph.phone}` : ""} to cancel the remaining refills, then log the call.</span>
                <button type="button" data-testid={`rx-refill-cancel-call-${i}`} onClick={() => onCallPharmacy(ph.id)} className="flex items-center gap-1 rounded-full bg-[#4E342E] px-3 py-1 text-[11px] font-bold text-white"><PhoneCall size={11} /> Log call</button>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
